import { useEffect, useMemo, useRef } from 'react';
import { useInfiniteQuery } from 'react-query';
import { apiService } from '../../../../services/ApiService';
import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spinner,
} from '@chakra-ui/react';

const LIMIT = 70;

const StationFilterInput = ({ onChange, value }) => {
  const menuListRef = useRef(null);

  const {
    data,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
  } = useInfiniteQuery({
    queryKey: ['stations-autocomplete-filter'],
    refetchOnWindowFocus: false,
    queryFn: async ({ pageParam = 0 }) => {
      return await apiService.getStations({
        limit: LIMIT,
        offset: pageParam,
      });
    },
    getNextPageParam: (lastPage, allPages) => {
      const items = lastPage?.data || [];

      if (items.length < LIMIT) {
        return undefined;
      }

      return allPages.length * LIMIT;
    },
  });

  const stationOptions = useMemo(
    () =>
      data?.pages
        ?.flatMap((page) => page?.data || [])
        .map((station) => ({
          label: station.name,
          value: station.id,
        })) || [],
    [data],
  );

  useEffect(() => {
    if (!value && stationOptions.length > 0) {
      onChange(stationOptions[0]);
    }
  }, [value, stationOptions, onChange]);

  const handleScroll = (event) => {
    const element = event.currentTarget;

    const isAtBottom =
      element.scrollHeight - element.scrollTop <= element.clientHeight + 20;

    if (isAtBottom && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  };

  return (
    <Menu variant="filter">
      <MenuButton
        as={Button}
        variant="secondary-md"
        color="white"
        w="200px"
        px="24px !important"
        isLoading={isLoading}
      >
        {value?.label || stationOptions[0]?.label || 'Select station'}
      </MenuButton>

      <MenuList
        ref={menuListRef}
        className="context-menu"
        maxH="300px"
        overflowY="auto"
        onScroll={handleScroll}
      >
        {stationOptions.map((option) => (
          <MenuItem key={option.value} onClick={() => onChange(option)}>
            {option.label}
          </MenuItem>
        ))}

        {isFetchingNextPage && (
          <MenuItem justifyContent="center" pointerEvents="none">
            <Spinner size="sm" />
          </MenuItem>
        )}
      </MenuList>
    </Menu>
  );
};

export default StationFilterInput;
